import * as Helper from '../helper/GlobalHelper'

const urlPlutoApi = `${process.env.REACT_APP_API_PLUTO}`

export type VolumeSettings = {
  RowKey: string
  SLCreated: string
  SLCreatedBy: string
  SLLastUpdated: string
  SLLastUpdatedBy: string
  SLNeedsVerification: string
  data: string
  deviceId: string
  locked: boolean
  type: string
}

export type PostVolumeSettings = {
  data: string
  deviceId: string
  type: string
}

export const postCameraAutofocus = async (cameraId: string, callAs: string) => {
  const body = { cameraId: cameraId }
  return await Helper.apiPost<any>(`${urlPlutoApi}/pluto-camera-control/calibrate${callAs}`, body)
}

export const getPlutoSettingByType = async (cameraId: string, type: 'volume') => {
  return await Helper.apiGet<VolumeSettings[]>(`${urlPlutoApi}/pluto-setting/swcs-${cameraId}/${type}`)
}

export const postPlutoSetting = async (body: PostVolumeSettings) => {
  return await Helper.apiPost<any>(`${urlPlutoApi}/pluto-setting/`, body)
}

export const setPlutoHeater = async (body: {
  cameraId: string
  hostname: string
  durationSeconds: number
}) => {
  return await Helper.apiPost<any>(`${urlPlutoApi}/pluto-camera-control/heater/set`, body)
}

export type PlutoHeaterStatus = {
  hostname: string
  success: boolean
  heaterEnabled: boolean
  heaterStatus: string
  manualControlDuration: number
  manualControlStartTime: number
}

export const getPlutoHeaterStatus = async (body: { cameraId: string; hostname: string }) => {
  return await Helper.apiPost<PlutoHeaterStatus>(`${urlPlutoApi}/pluto-camera-control/heater/status`, body)
}
